// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { string } from 'prop-types'

const Success = props => {
  const {
    idRoot,
    modalHeading,
    modalMessage,
  } = props

  return (
    <div className={'path-details-footer-modal'}>
      <h3 className={'center-text uppercase padding-half'}>
        <span
          className={'text-blue-dark'}
          id={`${idRoot}-heading`}>
          {modalHeading}
        </span>
        <span className={'confirmation-decoration'} />
      </h3>
      <p className={'padding-half center-text'}>
        <span id={`${idRoot}-message`}>
          {modalMessage}
        </span>
      </p>
    </div>
  )
}

Success.propTypes = {
  idRoot: string,
  modalHeading: string.isRequired,
  modalMessage: string.isRequired,
}

Success.defaultProps = {
  idRoot: 'success-modal',
}

export default Success
